import { useState } from "react";
import { Popover } from 'react-tiny-popover'
import { formatPrice } from "../../../../services/helpers/Helper";
import FormEditProduct from "./form-edit-product";

const ItemProduct = (props) => {
  const { product } = props;
  const { keywords, product_name, product_selling_price } = product;

  const [isEdit, setIsEdit] = useState(false);

  return (
    <div className="live-stream-list-product-item">
      <div className="item-container pointer">
        <div className="photo border-radius4 disable-select">
          {product.product_image ?
            <img src={product.product_image} alt="Product thumb" />
            :
            <div className="default d-flex-center">
              <div className="svg-next-icon image-default-v2">
              </div>
            </div>
          }
        </div>
        <div className="info-container">
          <div className="top display-flex">
            <div className="flex-1 min-w-0">
              <div className="line-height-16 ellipsis">
                <span className="cursor-auto" title={product_name}>{product_name}</span>
              </div>
              <div className="optional-value ellipsis line-height-16 font-size-12 mt6">
                <span className="cursor-auto">
                  <span className="ellipsis-space-pre italic" title="Sản phẩm tùy biến">
                    Sản phẩm tùy biến
                  </span>
                </span>
              </div>
            </div>
            <Popover
              isOpen={isEdit}
              align={'center'}
              positions={['top', 'bottom', 'left', 'right']}
              onClickOutside={() => setIsEdit(false)}
              clickOutsideCapture={true}
              content={<FormEditProduct product={product} onClose={() => setIsEdit(false)} />}
            >
              <div className="action-container ps-relative" onClick={() => setIsEdit(true)}>
                <div className="action-edit-container">
                  <div className="svg-next-icon ic-edit ic-edit-one-line">
                  </div>
                </div>
              </div>
            </Popover>
          </div>
          <div className="livestream-product-list-keyword">
            <div className="wrapper">
              {keywords && keywords.map((item, index) => {
                return (<div className="keyword font-size-12 primary" key={index}><span title={item.keyword} key={index}>{item.keyword}</span></div>);
              })}
            </div>
          </div>
          <div className="bottom-container display-flex">
            <div className="bottom-left">
              <div className="bottom-info display-flex-align-items-center"><span><span>
                <div className="svg-next-icon ic-inventory">
                </div>
              </span></span><span className="ml5 font-size-12 mt1">-</span></div>
              <div className="bullet-point">•</div>
              <div className="bottom-info display-flex-align-items-center"><span><span>
                <div className="svg-next-icon ic-user-check">
                </div>
              </span><span className="ml5 font-size-12 mt1">0</span></span></div>
            </div>
            <div className="bottom-right display-flex">
              <div><span className="text-font-weight-500 inline-block ml6">{formatPrice(product_selling_price)} ₫</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemProduct